import type { AlpineComponent } from 'alpinejs'
import { Action, Actor, adminDashboard, Page } from '../../Integrations/Tracking'

type Props = {
    page: Page
}

type Analytics = AlpineComponent<{
    on(eventName: string, callback: (event: any) => void): void
}>

const Component = (props: Props): Analytics => ({
    init() {
        adminDashboard.identify(props.page)
        adminDashboard.track(Actor.Contractor, Action.PageView, {
            page_name: props.page.pageName,
        })

        this.on('click-go-to-request', () => {
            adminDashboard.track(Actor.Contractor, Action.ClickGoToRequest, {
                from_workflow: 'new',
                to_workflow: 'old',
            })
        })

        this.on('open-task-detail', (event: any) => {
            adminDashboard.track(Actor.Contractor, Action.OpenTaskDetail, {
                task_type: event.detail.taskType,
            })
        })

        this.on('click-complete-task', (event: any) => {
            adminDashboard.track(Actor.Contractor, Action.ClickCompleteTask, {
                task_type: event.detail.taskType,
                completion_method: event.detail.completionMethod,
            })
        })
    },

    on(eventName: string, callback: (event: any) => void) {
        window.addEventListener(eventName, callback.bind(this))
    },
})

export default Component
